import type { FC, ReactNode } from "react";
import { cn } from "../../utils";
import type { GameRtpListVariant } from "./computeVariantStyle";
import GameRtpListInfo from "./GameRtpListInfo";
import GameRtpListRow, { type GameRtpListItem } from "./GameRtpListRow";

// Reserves space for 5 rows so the desktop panel doesn't resize when
// switching between the game list and the info panel.
const GAME_RTP_LIST_MIN_HEIGHT = "min-h-[336px]";

type Props = {
  isInfoOpen: boolean;
  infoContent?: ReactNode;
  items: GameRtpListItem[];
  variant: GameRtpListVariant;
};

const GameRtpListBody: FC<Props> = ({
  isInfoOpen,
  infoContent,
  items,
  variant,
}) => {
  if (isInfoOpen) {
    return (
      <GameRtpListInfo
        content={infoContent}
        className={cn(
          "m-1 rounded-2xl bg-background",
          GAME_RTP_LIST_MIN_HEIGHT,
        )}
      />
    );
  }

  return (
    <div
      className={cn(
        "flex flex-col gap-2 p-3 bg-background m-1 rounded-2xl",
        GAME_RTP_LIST_MIN_HEIGHT,
      )}
    >
      {items.map((item) => (
        <GameRtpListRow key={item.id} item={item} variant={variant} />
      ))}
    </div>
  );
};

export default GameRtpListBody;
